import Entity from '@/models/entities/Entity';
import { Font } from '@/models/entities/Font';

export class FontGroup implements Entity {
  public id: number = 0;
  public name: string = '';
  public totalFonts: number = 0;
  public fonts: Font[] = [];

  constructor(initData: Partial<FontGroup>) {
    Object.assign(this, initData);
  }
}
